window.newsletter =
{
    failed: function (data)
    {
        Swal.fire(
        {
            title: "Chyba!",
            text: "Při odesílání formuláře došlo k chybě. Zkontrolujte jestli je Vaše e-mailová adresa správně nebo to zkuste prosím později.",
            icon: "error",
        });
    },
    success: function (data)
    {
        Swal.fire(
        {
            title: "Úspěch!",
            text: "Váš e-mail byl úspěšně přidán.",
            icon: "success",
        });
    },
};